import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { IconButton } from '@mui/material'
import LogoMinhaVero from 'components/Svg/Logos/MinhaVero'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Center, Content, ImgLogo, Left, Right } from './styles'

function DefaultHeader() {
  const location = useLocation()
  const navigation = useNavigate()

  return (
    <Content>
      <Left>
        {location.pathname.includes('/auth/') && (
          <IconButton sx={{ paddingLeft: '20px' }} onClick={() => navigation(-1)}>
            <ArrowBackIcon fontSize='large' />
          </IconButton>
        )}
      </Left>
      <Center>{location.pathname.includes('/vero') ? <LogoMinhaVero /> : <ImgLogo src='/guigo-logo.png' alt='Guigo TV' />}</Center>
      <Right />
    </Content>
  )
}

export default DefaultHeader
